import { DateTime } from "luxon";

export const SHOW_INVOICES_FILTER = {
  Dashboard: true,
  Invoices: false,
  Payables: false,
  Receivables: false,
};


// Invoice states
export const RECEIVABLES = "receivables";
export const PAYABLES = "payables";
export const ALL_INVOICES = "allInvoices";

export const CURRENCIES_FILTER = [
  {
    displayTitle:"All",
    value: null,
  },
  {
    displayTitle: "AED",
    value: "AED",
  },
  {
    displayTitle: "USD",
    value: "USD",
  },
];

// Invoice constants
export const RECEIVABLE = "Receivable";
export const PAYABLE = "Payable";


// Transactions states
export const CREDIT = "credit";
export const DEBIT = "debit";
export const ALL_TRANSACTIONS = "allTransactions";

// Pagination constants
export const PAGE_SIZE = 15;

export const INVOICE_STATES = Object.freeze({
  DRAFT: 'DRAFT',
  COOLING: "COOLING",
  PAID: 'PAID',
  DUE: 'DUE',
  OVERDUE: 'OVERDUE',
  SETTLED: 'SETTLED',
  REJECTED: 'REJECTED',
  VOIDED: 'VOIDED',
});

export const LOG_ENTITIES = Object.freeze({
  INVOICE: 'Invoice',
  BANK: 'Bank',
  BANK_ACCOUNT: 'Bank Account',
  PAYMENT: 'Payment',
  PAYMENT_METHOD: 'Payment Method',
  TRANSACTION: 'Transaction',
});

export const ANALYTICS_DATES = Object.freeze({
  TODAY: "Today",
  TODAY_VALUE: "today",

  LAST_WEEK: "Last Week",
  LAST_WEEK_VALUE: "last_week",

  NEXT_WEEK: "Next Week",
  NEXT_WEEK_VALUE: "next_week",

  LAST_MONTH: "Last Month",
  LAST_MONTH_VALUE: "last_month",
  
  NEXT_MONTH: "Next Month",
  NEXT_MONTH_VALUE: "next_month",

  LAST_7_DAYS: "Last 7 Days",
  LAST_7_DAYS_VALUE: "last_7_days",

  NEXT_7_DAYS: "Next 7 Days",
  Next_7_DAYS_VALUE: "next_7_days",

  LAST_30_DAYS: "Last 30 Days",
  LAST_30_DAYS_VALUE: "last_30_days",

  NEXT_30_DAYS: "Next 30 Days",
  NEXT_30_DAYS_VALUE: "next_30_days",

  LAST_THREE_MONTHS: "Last Three Months",
  LAST_THREE_MONTHS_VALUE: "last_three_months",

  THIS_YEAR: "This Year",
  THIS_YEAR_VALUE: "this_year",
});

export const QUERY_PARAMETERS = Object.freeze({
  PAGE_NO: 'page',
  START_TIME: 'due_start_time',
  END_TIME: 'due_end_time',
  ISSUE_START_TIME: 'issue_start_time',
  ISSUE_END_TIME: 'issue_end_time',
  SORT: "sort",
  SEARCH: 'search',

  // Invoice Params
  TYPE: 'type',
  STATUS: 'status',
  CURRENCY: "currency",

  // Activity Logs Params
  ENTITY: 'entity_type',

  // Transactions Params
  TRANSACTION_TYPE: 'transaction_type'
});


export const PERMISSIONS = {
  ACCOUNTS_ALL: "accounts:all",
  BUSINESSES_ALL: "businesses:all",
  INVOICES_ALL: "invoices:all",
  INVOICES_BASE: "invoices:base",
  LOGS_ALL: "logs:all",
  LOGS_BASE: "logs:base",
  ROLES_ALL: "roles:all"
};

export const PAYMENT_TERMS = {
  NOW: 'NOW',
  NET_30: 'NET 30',
  NET_60: 'NET 60',
  CUSTOM: 'CUSTOM',
};

const today = DateTime.now();
const todayStart = today.startOf('day');

export const DUE_DATE_LABELS = [
  {
    label: PAYMENT_TERMS.NOW,
    dateFn: (date=today) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date)
      }
      return date.endOf('day');
    }, 
  },
  {
    label: PAYMENT_TERMS.NET_30,
    dateFn: (date=today) => {
      if (date instanceof Date) {
       date = DateTime.fromJSDate(date);
      }
      return date.plus({days: 40}).endOf('day');
    },
  },
  {
    label: PAYMENT_TERMS.NET_60,
    dateFn: (date=today) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      return date.plus({days: 60}).endOf('day');
    },
  }
];

export const ISSUE_DATE_LABELS = [
  {
    label: "TODAY",
    dateFn: () => todayStart
  },
  {
    label: "YESTERDAY",
    dateFn: () => todayStart.minus({days: 1}),
  },
  {
    label: "TOMORROW",
    dateFn: () => todayStart.plus({days: 1}),
  }
];

export const EDIT_INVOICE_ISSUE_DATE_LABELS = [
  {
    label: "CURRENT DAY",
    dateFn: (date) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      return date.startOf('day');
    }
  },
  {
    label: "ONE DAY AGO",
    dateFn: (date) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      const val = date.minus({days:1}).startOf('day')
      console.log(val.toISO());
      return val;
    },
  },
  {
    label: "ONE DAY LATER",
    dateFn: (date) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      return date.plus({days: 1}).startOf('day');
    },
  }
];

export const BUSINESS_ADMIN_NAME = "Admin";

export const PAYMENT_FLAVOR_TEXTS = [
  "Connecting to your bank for the payment request...",
  "Please wait while we process your payment request...",
  "Hang on, this could take a while...",
];

export const NOT_SUPPORTED_BANKS = [
  "Select your bank",
  "Abu Dhabi Islamic Bank",
  "Ajman Bank",
  "Al Hilal Bank",
  "Al Maryah Community Bank",
  "Al Masraf Arab Bank for Investment & Foreign Trade",
  "Bank of Sharjah",
  "Commercial Bank International",
  "Dubai Bank",
  "Dubai Finance Bank",
  "Dubai Islamic Bank",
  "Emirates Investment Bank",
  "Invest Bank",
  "National Bank of Fujairah",
  "National Bank of Umm Al-Quwain",
  "Noor Bank",
  "Sharjah Islamic Bank",
  "United Arab Bank",
  "Wio Bank",
  "Other"
];